import clsx from "clsx"
import { type ReactNode, useEffect, useState } from "react"
import { useLocation, useNavigate } from "react-router-dom"
import { PageWrapper, Tab, type TabItem } from "@/shared/components"
import { getLastPath } from "@/shared/utils"
import type { TAB_PAGES } from "../type"
import "./index.scss"
import { useTranslation } from "react-i18next"

const TABS: Record<TAB_PAGES, TabItem> = {
  announcements: {
    label: "announcement",
    path: "announcements"
  },
  current: {
    label: "current",
    path: "current"
  },
  completed: {
    label: "completed_items",
    path: "completed"
  }
}

export const EnergyAuditWrapper = ({ header, children }: { header: ReactNode; children: ReactNode }) => {
  const { t } = useTranslation("sidebar")
  const [tab, setTab] = useState(TABS.announcements)
  const navigate = useNavigate()
  const { pathname } = useLocation()
  const last = getLastPath(pathname)

  const onTabChange = (newTab: TabItem) => {
    setTab(newTab)
    navigate(`/dashboard/energy-audit/${newTab.path}`)
  }

  useEffect(() => {
    setTab(TABS[last as TAB_PAGES])
  }, [pathname])

  return (
    <PageWrapper>
      {header}
      <Tab
        spacing={20}
        size="sm"
        tabs={Object.values(TABS)}
        renderTab={k => (
          <div className="flex items-center gap-2">
            <span className={clsx("h-2.5 w-2.5 rounded-full", k.path === tab.path ? "bg-blue-600" : "bg-DarkGray")} />
            {t(k.label)}
          </div>
        )}
        value={tab}
        onChange={onTabChange}
      />
      <div className="flex h-full flex-col overflow-hidden">{children}</div>
    </PageWrapper>
  )
}
